import { render, staticRenderFns } from "./ModalFavoriteContacts.vue?vue&type=template&id=9a66bb80&"
import script from "./ModalFavoriteContacts.vue?vue&type=script&lang=js&"
export * from "./ModalFavoriteContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports